// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"6100ab52ea454e6e782b","888":"aafe1c10b48113311f39"}[chunkId] + ".css";
};